/* ===========================================================================
   Dropdown (fake select)
   =========================================================================== */

import {openClass} from "../settings/settings";

export function dropdown() {
  if ($('select.js-dropdown-target').length) {

    // Wait a bit to make sure selects are fully loaded
    setTimeout(function() {
      let realSelect = $(".js-dropdown-target"),
        realOption = $(".js-dropdown-target option"),
        fakeSelectedValue = $(".l-dropdown-selected-value"),
        dropdownList = $(".l-dropdown-list");

      // Cleaning the values on load
      function cleanValues() {
        fakeSelectedValue.empty();
        dropdownList.removeClass("open").empty();
      }

      // Getting the default selected option
      function getDefaultSelected() {
        realSelect.each(function() {
          let defaultSelectedOption = $(this).find(":selected").html();
          let defaultDataValue = $(this).find(":selected").val();
          let defaultActionSearch = $(this).find(":selected").attr('ref-action');
          $(this).parent().find(".l-dropdown-selected-value").append(defaultSelectedOption);
          $(this).parent().find(".l-dropdown-selected-value").attr('data-value', defaultDataValue);
          $(this).parent().closest('form').attr('action', defaultActionSearch);
        });
      }

      // Cloning the real select options to the fake one

      function cloneSelect() {
        const $dropDownTargetSelect = $(".js-dropdown-target");
        const $dropDownTargetSelectOptions = $dropDownTargetSelect.find('option');
        $dropDownTargetSelectOptions.each(function() {
          $(this).parent()
            .next('.l-dropdown')
            .find('.l-dropdown-list')
            .append(
              `<li class="l-dropdown-item${$(this).prop("disabled") ? ' l-dropdown-item-disabled' : ''}${$(this).prop('selected') ? ' item-active' : ''}" data-value="${$(this).val()}">${$(this).html()}</li>`
            );
        });

        $dropDownTargetSelect.next('.l-dropdown').find('.l-dropdown-item:not(.l-dropdown-item-disabled)').click(function() {
          const $selectTriggerItem = $(this);
          let selected_value = $selectTriggerItem.html(),
            data_value = $selectTriggerItem.attr('data-value');

          $selectTriggerItem.parent().parent().find(".l-dropdown-selected-value").attr('data-value', data_value).html(selected_value);

          if ($dropDownTargetSelect[0].id = "itemSize-Selector") {
            $selectTriggerItem.siblings('.item-active').each(function() {
              $(this).removeClass('item-active');
            });
            $selectTriggerItem.addClass('item-active');
          }

          dropdownList.removeClass("open");

          // Linking the front selected option to the real select option
          $(this).parent().parent().parent().find('option[value="'+ data_value +'"]').prop('selected', 'selected').change();
          $(this).parent().parent().parent().attr('action', $(this).parent().parent().parent().find('option[value="'+ data_value +'"]').attr('ref-action'));
        });
      }

      cleanValues();

      // Open/Close dropdown
      fakeSelectedValue.click(function() {
        $(this).each(function() {
          $(this).next(".l-dropdown-list").toggleClass("open");
        });
      });

      getDefaultSelected();
      cloneSelect();

      // Detects when the <select> content is changing
      realSelect.on('DOMSubtreeModified', function(){
        cleanValues();
        getDefaultSelected();
        cloneSelect();
      });

      $(document).mouseup(function(e) {
        let target = e.target;

        if (!dropdownList.is(target) && dropdownList.has(target).length === 0) {
          dropdownList.removeClass("open");
        }
      });

    },1000);
  }
}

$( document ).ready(function() {
  dropdown();

  $(".command-button-show.icon-arrow-top").click(function() {
    $(this).toggleClass(openClass);
  });
});
